import { SVC_A, SVC_B } from './base' // eslint-disable-line
// import { ruleClassMap } from '../util/alertRuleMap'
import moment from 'moment'
import queryString from 'query-string'

export function getEventsForCameraUUID (domainUUID, cameraUUID, params) {
  const query = queryString.stringify(params)
  return SVC_A.get(`/api/events/v1/alerts?domain_uuid=${domainUUID}&camera_uuid=${cameraUUID}&${query}`)
}

export function getEventsByDomainUUID (domainUUID, params) {
  const query = queryString.stringify(params)
  return SVC_A.get(`/api/events/v1/alerts?domain_uuid=${domainUUID}&${query}`)
}

// function parses event data for display in viewer timeline
export function parseEventPoints (data) {
  let items = data.map(notification => {
    const metrics = parseObjectsToMetrics(notification.info.objects)
    const alertType = parseEventClass(metrics)
    let timestamp = moment.utc(notification.info.started_at).format()
    let item = {
      id: notification.id,
      content: '',
      title: `${alertType} detected`,
      group: 0,
      start: timestamp,
      className: alertType,
      type: 'point',
    }
    return item
  })
  return items
}
function parseObjectsToMetrics (objects) {
  let metricsMap = {}
  objects.forEach(object => {
    if (!(object in metricsMap)) {
      metricsMap[object] = 1
    } else {
      metricsMap[object] += 1
    }
  })
  return metricsMap
}

// Counts the object types for each alert.
function metricsFromAlert (alert) {
  const metricsMap = {}
  alert.info.objects.forEach(object => {
    if (!(object in metricsMap)) {
      metricsMap[object] = 1
    } else {
      metricsMap[object] += 1
    }
  })
  const metrics = Object.keys(metricsMap).map(key => {
    return {
      [key]: metricsMap[key],
    }
  })
  return metrics
}

// Computes metrics for an alert, then returns a transformed alert.
export function transformAlert (alert) {
  const timestamp = moment.utc(alert.info.started_at).format()
  const metrics = alert.info.objects && metricsFromAlert(alert)
  const event = {
    id: alert.id,
    title: alert.description,
    category: alert.category,
    className: alert.info.objects ? alert.info.objects.toString() : 'unknown',
    cameraId: alert.camera_uuid,
    image: alert.thumbnail_uri,
    cameraDescription: alert.camera_description,
    cameraTags: alert.camera_tags,
    timestamp,
    metrics,
  }
  return event
}

// Calls `transformAlert` on an array of alerts.
export function parseEventCards (alerts) {
  const events = alerts.map(alert => {
    return transformAlert(alert)
  })

  return events
}

function parseEventClass (metricsDict) { // eslint-disable-line
  if (metricsDict.pet > 0) {
    return 'pet'
  } else if (metricsDict.car || metricsDict.truck) {
    return 'vehicle'
  } else if (metricsDict.box) {
    return 'box'
  } else {
    return 'person'
  }
}

function parseMetrics (metrics) { // eslint-disable-line
  const detectionsDict = {}
  for (var metric in metrics) {
    if (metric.includes('confidence_')) {
      continue
    }
    if (metrics[metric] === 0) {
      continue
    }

    const label = metric.replace('ssd_', '')

    if (metric in detectionsDict) {
      detectionsDict[label] += metrics[metric]
    } else {
      detectionsDict[label] = metrics[metric]
    }
  }

  const detections = []

  for (var detectable in detectionsDict) { // eslint-disable-line
    detections.push({ description: detectable, detections: detectionsDict[detectable] })
  }
  // console.log(detections.length, detections)
  return detections
}
